import React, { Fragment } from 'react';
import SurveyQuestion from '../../components/Surveys/SurveyQuestion';
import AlertDialog from '../../components/AlertDialog';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import { flattenArray, getWorkspace } from '../../utils/miscFunctions';
import QuestionSummary from '../../components/Surveys/QuestionSummary';
import { SurveyContext } from '../../SurveyContext';

const COORDINATE_ALLOCATOR_PROXY = 'https://surveys.elucd.com';
class SurveyPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: this.props.match.params.id,
            data: null,
            currentWorkspace: '',
            openDelete: false,
            openSummary: false,
            embed: false,
            loading: true,
            openSnackbar: false,
            snackbarMessage: '',
        }
        this.fieldRefs = [];
    }

    // on page load, if url contains id, load typeform data for given id
    async componentDidMount() {
        if (this.state.uid) {
            let answer = await fetch(`/.netlify/functions/typeform?type=getSingle&uid=${this.state.uid}`).then(response =>
                response.json()
            ).catch(err => console.log(err));
            this.setState({
                data: answer.message,
                currentWorkspace: getWorkspace(answer.message.workspace),
                loading: false,
            })
            console.log("Single typeform: ", answer);
        } else {
            console.log("No UID");
        }
    }

    toggleSummary = () => {
        this.setState({
            openSummary: !this.state.openSummary
        });
    }

    toggleDeleteDialog = () => {
        this.setState({
            openDelete: !this.state.openDelete
        });
    }

    toggleSnackbar = () => {
        this.setState({
            openSnackbar: !this.state.openSnackbar
        });
    }

    // when ref is clicked on sidebar, scroll to question ref on survey page
    scrollToQuestion = (idx) => {
        window.scrollTo(0, this.fieldRefs[idx].offsetTop);
    }

    copySurveyLink = () => {
        const copyText = document.getElementById('coordinate-allocator-survey-link');
        copyText.select();
        document.execCommand('copy');
    }

    render() {
        const { data, currentWorkspace, openSnackbar, snackbarMessage, loading } = this.state;

        return (
            <div style={{ position: 'relative', width: '100%' }}>
                <div>
                    <h3 style={{ marginLeft: 120, maxWidth: '65%' }}> {data ? data.title : 'Survey Name'} </h3>
                </div>
                <Button style={{ position: 'absolute', left: 20, top: 0, margin: 0 }} variant='outlined' color="secondary" onClick={() => this.props.history.push('/surveys')}> Back</Button>
                <Button style={{ position: 'absolute', right: 120, top: 0, margin: 0 }} variant='outlined' color="primary" onClick={() => this.props.history.push(`/surveys/${this.state.uid}/edit`)}> Edit </Button>
                <Button style={{ position: 'absolute', right: 20, top: 0, margin: 0 }} variant='outlined' color="primary" onClick={() => this.props.history.push(`/surveys/create/${this.state.uid}`)}> Copy </Button>
                <hr style={{ marginTop: 30 }} />
                {data ?
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div style={{ width: '25%', height: '100vh', overflow: 'scroll', top: 0, position: 'sticky', padding: 10 }}>
                            <h3> {`Typeform ID: ${data.id}`} </h3>
                            <p> <b> Workspace: </b>  {currentWorkspace}</p>
                            <p> <b> Language: </b>  {data.settings.language}</p>
                            <a target="_blank" href={`https://admin.typeform.com/form/${data.id}/create`} rel="noopener noreferrer"> Admin Link </a>
                            <div style={{ margin: '16px 0px' }}>
                                <textarea 
                                    style={{ border: 'none', resize: 'none', width: '100%' }} 
                                    id="coordinate-allocator-survey-link" 
                                    value={`${COORDINATE_ALLOCATOR_PROXY}/to/${data.id}`} 
                                /> 
                                <Button
                                    variant='outlined' 
                                    color="primary" 
                                    onClick={this.copySurveyLink}
                                >
                                Copy Survey Link
                                </Button>
                            </div>
                            <Button variant='outlined' color="primary" onClick={this.toggleSummary}>Question Summary</Button>
                            <hr />
                            {data.hidden &&
                                <Fragment>
                                    <h3> Hidden Fields: </h3>
                                    <p>{flattenArray(data.hidden)}</p>
                                </Fragment>
                            }
                            <h3> Fields: </h3>
                            {data.fields &&
                                <ol style={{ paddingLeft: 20, paddingRight: 20 }}>
                                    {data.fields.map((field, idx) => (
                                        <li key={idx} style={{ cursor: 'pointer', marginBottom: 10 }} onClick={() => this.scrollToQuestion(idx)}>
                                            {field.ref}
                                            {field.type === 'group' &&
                                                field.properties.fields &&
                                                <ol type="a" style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}>
                                                    {field.properties.fields.map((field, fieldIdx) => (
                                                        <li key={fieldIdx} style={{ marginBottom: 8 }}> {field.ref} </li>
                                                    ))}
                                                </ol>
                                            }
                                        </li>
                                    ))}
                                </ol>
                            }
                        </div>
                        <div style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }} >
                                {data.welcome_screens &&
                                    <Fragment>
                                        <div style={styles['question']}>
                                            <span style={styles['span']}>
                                                <p style={styles['number']}>
                                                    <b> Welcome Screen </b>
                                                </p>
                                                <span style={{ float: 'right' }}>
                                                    <b> Ref: </b>
                                                    <p style={{ display: 'inline-block', fontSize: '1.3rem', margin: 0 }}> {data.welcome_screens[0]['ref']}</p>
                                                </span>
                                            </span>
                                            <p style={styles['text']}>
                                                {data.welcome_screens[0]['title']}
                                            </p>
                                            <div style={styles['details']}>
                                                <p><b>Description: </b>{` ${data.welcome_screens[0]['properties']['description']}`}</p>
                                            </div>
                                        </div>
                                    </Fragment>
                                }
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }} >
                                {data.fields &&
                                    <Fragment>
                                        {data.fields.map((question, idx) => {
                                            return (
                                                <div
                                                    style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', margin: 5 }}
                                                    ref={fieldRef => this.fieldRefs[idx] = fieldRef}
                                                    key={idx}
                                                >
                                                    <SurveyQuestion
                                                        question={question}
                                                        idx={idx}
                                                    />
                                                </div>
                                            )
                                        })}
                                    </Fragment>
                                }
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }} >
                                {data.thankyou_screens &&
                                    <Fragment>
                                        {data.thankyou_screens.length > 1 &&
                                            <Fragment>
                                                <div style={styles['question']}>
                                                    <span style={styles['span']}>
                                                        <p style={styles['number']}>
                                                            <b> Thank you Screen </b>
                                                        </p>
                                                        <span style={{ float: 'right' }}>
                                                            <b> Ref: </b>
                                                            <p style={{ display: 'inline-block', fontSize: '1.3rem', margin: 0 }}> {data.thankyou_screens[0]['ref']}</p>
                                                        </span>
                                                    </span>
                                                    <p style={styles['text']}>
                                                        {data.thankyou_screens[0]['title']}
                                                    </p>
                                                    <div style={styles['details']}>
                                                    </div>
                                                </div>
                                            </Fragment>
                                        }
                                    </Fragment>
                                }
                            </div>
                        </div>
                    </div>
                    :
                    <h1> {loading ? "Loading..." : "Error loading survey data"} </h1>
                }
                <QuestionSummary
                    open={this.state.openSummary}
                    toggleOpen={this.toggleSummary}
                    fields={(data && data.fields) ? data.fields : []}
                />
                <AlertDialog
                    open={this.state.openDelete}
                    title={"Delete this form?"}
                    text={"Are you sure you want to delete this form? This will delete the form and all of its responses. This action can not be undone."}
                    noClick={this.toggleDeleteDialog}
                    yesClick={this.deleteTypeform}
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={openSnackbar}
                    autoHideDuration={2000}
                    onClose={this.toggleSnackbar}
                    message={snackbarMessage}
                    action={
                        <IconButton size="small" aria-label="close" color="inherit" onClick={this.toggleSnackbar}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    }
                    style={{ fontSize: 14 }}
                />
                <Backdrop open={loading} style={{ zIndex: 5, color: '#fff' }}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        )
    }
};

const styles = {
    'question': {
        border: '1px solid black',
        width: '80%',
        margin: '3px',
        padding: 0,
        boxSizing: 'border-box'
    },
    'span': {
        boxSizing: 'border-box',
        width: '100%',
        display: 'inline-block',
        borderBottom: '1px solid',
        padding: '1rem'
    },
    'number': {
        fontSize: '1.3rem',
        float: 'left',
        margin: 0,
        lineHeight: '1'
    },
    'text': {
        margin: 0,
        padding: '1em',
        float: 'left',
        lineHeight: 1.4,
        fontSize: '1.2rem',
    },
    'details': {
        background: '#CCC',
        float: 'left',
        padding: '0 1em',
        width: '100%',
        boxSizing: 'border-box',
        display: 'inline-block',
    }
}

SurveyPage.contextType = SurveyContext;

export default SurveyPage;